import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface TopMenuStyleProps {
  hasStats: boolean
}
const useStyles = makeStyles<Theme, TopMenuStyleProps>(theme => ({
  root: {
    display: ({ hasStats }) => (hasStats ? 'flex' : 'grid'),
    gridTemplateColumns: ({ hasStats }) => (hasStats ? '' : '1fr auto'),
    alignItems: 'center',
    borderBottom: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    height: '80px',
    paddingLeft: '24px',
    paddingRight: '36px',
    background: 'white',

    [theme.breakpoints.down('md')]: {
      display: 'flex',
      marginBottom: '0'
    }
  },

  searchArea: {
    display: 'flex',
    alignItems: 'center'
  },

  notificationsArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '1'
  },

  mobileRoot: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',
    borderBottom: '0.0625rem solid #F1F1F1',
    boxSizing: 'border-box',
    padding: '1rem 0',

    [theme.breakpoints.down('md')]: {
      marginBottom: '0'
    }
  },

  hamburgerMenu: {
    display: 'flex',
    alignItems: 'center',
    flexBasis: '100%',
    justifyContent: 'flex-end'
  }
}))

export default useStyles
